import axiosInstance from "../instance/axiosInstance";

class CategoriesApi {
  static async createCategory(formData) {
    try {
      const response = await axiosInstance.post(
        "/product-category/save",
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async categoriesList(page, searchQuery, paginated = true) {
    let url = `/product-category/list?paginate=${paginated}&page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteCategory(id) {
    try {
      const response = await axiosInstance.get(
        `/product-category/delete/${id}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async editCategory(id) {
    try {
      const response = await axiosInstance.get(`/product-category/edit/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default CategoriesApi;
